import { cn } from "@punchup/utils/cn";

export default function VideoTitleHeader({
  children,
  className,
  responsive,
}: {
  children: React.ReactNode;
  className?: string;
  responsive?: boolean;
}) {
  const fontSize = responsive ? "text-3xl md:text-6xl" : "text-6xl";
  return (
    <h2
      className={cn(
        fontSize,
        "uppercase font-anton font-medium text-black",
        className
      )}
    >
      {children}
    </h2>
  );
}
